function convertBasedOnLevel(type, level, isCrazed, isBahamut, stat) {
  // Bahamut, Lv 30+
  if (isBahamut && level > 30) {
    return stat * (1 + 29 * 0.2 + (level - 30) * 0.1);
  }
  // Crazed, Lv 0-20
  if (typeof isCrazed !== "object" && level < 21) {
    return stat * (1 + (level - 1) * 0.2);
    // Crazed, Lv 21+
  } else if (typeof isCrazed !== "object" && level > 20) {
    return stat * (1 + 19 * 0.2 + (level - 20) * 0.1);
    // Basic, Special, Rare, Super Rare, Uber Super Rare, Lv<61
  } else if (level < 61) {
    return stat * (1 + (level - 1) * 0.2);
    // Basic, Special, Super Rare, Uber Super Rare, Lv 61-80
  } else if (level < 81 && type !== "Rare") {
    return stat * (1 + 59 * 0.2 + (level - 60) * 0.1);
    // Rare, Lv 61-70
  } else if (level < 71 && type === "Rare") {
    return stat * (1 + (level - 1) * 0.2);
    // Rare, Lv 71-90
  } else if (level < 91 && type === "Rare") {
    return stat * (1 + 69 * 0.2 + (level - 70) * 0.1);
    // Super Rare, Uber Super Rare, Lv 81+
  } else if (
    level > 80 &&
    (type === "Super Rare" || type === "Uber Super Rare")
  ) {
    return stat * (1 + 59 * 0.2 + 20 * 0.1 + (level - 80) * 0.05);
    // Rare, Lv 90+
  } else if (level > 90 && type === "Rare") {
    return stat * (1 + 69 * 0.2 + 20 * 0.1 + (level - 90) * 0.05);
    // Basic, Special, Lv 60+
  } else if (level > 60) {
    return stat * (1 + 59 * 0.2 + (level - 60) * 0.1);
  }
}

module.exports = convertBasedOnLevel;



// WEBPACK FOOTER //
// ./src/components-kr/utilities/calc-stats.js